(() => {
  const purchaseSelector = '[data-product-grid-purchase]';
  let initTimer = null;
  let initAttempts = 0;
  let alignTimer = null;

  const alignCarouselCards = () => {
    document.querySelectorAll('.carousel').forEach((carousel) => {
      const summaries = carousel.querySelectorAll('.product-grid-item--with-purchase > .product-grid-item__info');
      if (!summaries.length) return;

      summaries.forEach((summary) => summary.style.removeProperty('min-height'));

      const visibleSummaries = Array.from(summaries).filter((summary) => summary.offsetParent !== null);
      if (!visibleSummaries.length) return;

      const maxSummaryHeight = Math.max(...visibleSummaries.map((summary) => summary.offsetHeight));
      visibleSummaries.forEach((summary) => summary.style.setProperty('min-height', `${maxSummaryHeight}px`));
    });
  };

  const scheduleCarouselAlignment = () => {
    window.clearTimeout(alignTimer);
    alignTimer = window.setTimeout(() => window.requestAnimationFrame(alignCarouselCards), 50);
  };

  const initPaymentButtons = () => {
    if (!document.querySelector(purchaseSelector)) return;

    if (window.Shopify?.PaymentButton) {
      window.Shopify.PaymentButton.init();
      initAttempts = 0;
      scheduleCarouselAlignment();
      return;
    }

    if (initAttempts < 20) {
      initAttempts += 1;
      initTimer = window.setTimeout(initPaymentButtons, 100);
    }
  };

  const schedulePaymentButtonInit = () => {
    window.clearTimeout(initTimer);
    initTimer = window.setTimeout(initPaymentButtons, 0);
    scheduleCarouselAlignment();
  };

  const containsPurchaseControls = (node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    return node.matches(purchaseSelector) || Boolean(node.querySelector(purchaseSelector));
  };

  const observer = new MutationObserver((mutations) => {
    const purchaseControlsAdded = mutations.some((mutation) => Array.from(mutation.addedNodes).some(containsPurchaseControls));
    if (purchaseControlsAdded) schedulePaymentButtonInit();
  });

  const init = () => {
    initPaymentButtons();
    scheduleCarouselAlignment();
    observer.observe(document.body, {childList: true, subtree: true});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once: true});
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', schedulePaymentButtonInit);
  document.addEventListener('theme:resize:width', scheduleCarouselAlignment);
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-tabs-link]')) scheduleCarouselAlignment();
  });
  window.addEventListener('load', scheduleCarouselAlignment, {once: true});
})();
